"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var system_1 = require("@retriever-ui/system");
var react_1 = __importDefault(require("react"));
var SBase = __importStar(require("../base.styled"));
var Messages_1 = __importDefault(require("../Messages"));
var S = __importStar(require("./text.styled"));
var Text = function (_a, ref) {
    var label = _a.label, _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.type, type = _c === void 0 ? 'text' : _c, error = _a.error, props = __rest(_a, ["label", "name", "type", "error"]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(system_1.retriever.div, { display: "flex", flexDirection: "column-reverse" },
            react_1.default.createElement(S.TextInputField, __assign({ name: name, type: type, errored: ((error === null || error === void 0 ? void 0 : error.message) !== undefined &&
                    !props.disabled &&
                    !props.readOnly) ||
                    false, id: name, ref: ref }, props)),
            react_1.default.createElement(SBase.BaseLabel, { htmlFor: name }, label)),
        react_1.default.createElement(Messages_1.default, { warningMessage: props.warningMessage, disabled: props.disabled, readOnly: props.readOnly, error: error })));
};
exports.default = react_1.default.forwardRef(Text);
